import React, { useEffect } from 'react'
import MiniDrawer from '../../Component/newNavBarCM/newNavBar';
import MainFile from '../../Component/cmOverview/MainFile';
export default function CmHomePage() {
  useEffect(()=>{
  });
  return (
    <>      
        <MainFile/>
    </>
  )
}
